export default __webpack_public_path__ + "static/media/M_Macaco.41360b74.svg";